/*
 * Public API Surface of angularx-qrcode
 */

export { QRCodeComponent } from './lib/angularx-qrcode.component';
export { QRCodeModule } from './lib/angularx-qrcode.module';
export * from './lib/types';
